import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type {
  CreateModelAssetParams,
  Error
} from '@eggplant/types'

interface Props {
  modelId: string
  assetId: string
  params?: CreateModelAssetParams
  onError?: (error: Error) => void
  onSuccess?: () => void
  children?: () => void
}

const UpdateAiModelAssetRequest = ({
  modelId,
  assetId,
  params,
  onError,
  onSuccess,
  children
}: Props) => {
  const url = `${AI_API_SERVICE}/models/${modelId}/assets/${assetId}`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='put'
      onError={onError}
      onSuccess={onSuccess}
      params={params}
      url={url}
    />
  )
}

export default UpdateAiModelAssetRequest
